// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2n1Lv","col":"styles_col__3hgyr"};